"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTNativeUpload = void 0;
const axios_1 = __importDefault(require("axios"));
const _1 = require(".");
const types_1 = require("./types");
exports.FTNativeUpload = {
    upload(url, path, method, headers, progressCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            for (const key of Object.keys(headers)) {
                formData.append(key, headers[key]);
            }
            // File must come last, because AWS ignores all fields after 'file'
            // https://stackoverflow.com/questions/15234496/upload-directly-to-amazon-s3-using-ajax-returning-error-bucket-post-must-contai/15235866#15235866
            if ((0, types_1.isFileWithPath)(path)) {
                // @ts-ignore FormData inside React Native is different than web
                formData.append('file', {
                    uri: path.path,
                    name: path.name,
                    type: path.type,
                });
            }
            else {
                // This should be a nice trick to get web to work properly.
                formData.append('file', path);
            }
            const axiosOpts = {
                onUploadProgress: ({ loaded, total }) => {
                    if (progressCallback) {
                        progressCallback(loaded, total);
                    }
                },
            };
            let result;
            if (method === _1.HTTPMethod.POST) {
                result = yield axios_1.default.post(url, formData, axiosOpts);
            }
            else if (method === _1.HTTPMethod.PUT) {
                if ((0, types_1.isFileWithPath)(path)) {
                    throw new Error('Cannot upload file with path in PUT mode.');
                }
                result = yield axios_1.default.put(url, path, axiosOpts);
            }
            else {
                throw new Error(`Invalid method: ${method}`);
            }
            if (result.status >= 400) {
                const error = new types_1.UploadError('There was an error uploading that file.');
                error.originalResponse = result;
                throw error;
            }
        });
    },
};
//# sourceMappingURL=uploader.js.map